import React, { useEffect, useState } from 'react';
import { currentSession, impersonationActive, stopImpersonation } from '../service/impersonation';
import './ImpersonationBanner.css';

export default function ImpersonationBanner() {
    const [busy, setBusy] = useState(false);
    const [error, setError] = useState('');
    const [now, setNow] = useState(Date.now);
    useEffect(() => {
        const interval = window.setInterval(() => setNow(Date.now()), 30000);
        return () => window.clearInterval(interval);
    }, []);
    if (!impersonationActive()) return null;
    const data = currentSession()?.data;
    const user = data?.adminUser || {};
    const expired = data?.impersonation && new Date(data.impersonation.expiresAt).getTime() <= now;
    const back = async () => {
        setBusy(true); setError('');
        try { await stopImpersonation(); }
        catch (err) { setError(err.response?.data?.message || 'No pudimos volver a tu cuenta. Intenta nuevamente.'); setBusy(false); }
    };
    return <aside className="impersonation-banner" role="region" aria-label="Sesión de impersonación">
        <div><strong>{expired ? 'Impersonación vencida' : 'Actuando como'}: {[user.firstName, user.lastName].filter(Boolean).join(' ') || user.email}</strong>
            <span> · {user.role?.title || user.role?.uid || 'Sin rol'} · Los cambios son reales.</span>
            <small>Esta sesión se comparte entre las pestañas de Syncro de este navegador.</small>
            {error && <div role="alert">{error}</div>}
        </div>
        <button type="button" onClick={back} disabled={busy}>{busy ? 'Volviendo…' : 'Volver a mi cuenta'}</button>
    </aside>;
}
